import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=fbfc1930&"
import script from "./Header.vue?vue&type=script&lang=js&"
export * from "./Header.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fbfc1930')) {
      api.createRecord('fbfc1930', component.options)
    } else {
      api.reload('fbfc1930', component.options)
    }
    module.hot.accept("./Header.vue?vue&type=template&id=fbfc1930&", function () {
      api.rerender('fbfc1930', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/General/Header/Header.vue"
export default component.exports